<template>
  <div v-show="exam_show" class="module-wrap module-analyuze" :examData="examData">
    <h2 >{{moduleTitle}}</h2>
    <p class="pie-exam-title">{{title}}</p>
    <div id="pieExam" class="pie-custom" style="width: 680px; height: 300px"></div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: 'ModuleExam',
  props: ['examData'],
  data() {
    return {
      data: null,
      exam_show: false,
      moduleTitle: '中考分析',
      title: '中考知识点占比',
    };
  },
  mounted() {
  },
  methods: {
    transformObj2Array(obj) {
      const arr = [];
      for (const item in obj) {
        arr.push(obj[item]);
      }
      return arr;
    },
    renderData() {
      const { type, data } = this.examData;
      const typeMap = {
        primary: '小考',
        junior: '中考',
        senior: '高考',
      };
      const pieDatas = this.transformObj2Array(data);
      this.exam_show = false;
      if (pieDatas.length > 0) {
        this.moduleTitle = `${typeMap[type]}分析`;
        this.title = `${typeMap[type]}知识点占比`;
        const text = `${typeMap[type]}`;
        this.exam_show = true;
        this.renderPie(pieDatas, text);
      }
    },
    renderPie(data, text) {
      const dom = document.getElementById('pieExam');
      const myChart = echarts.init(dom);
      const pieTitle = '';
      let option = null;
      option = {
        title: {
          // text: `${text}知识点分析`,
          x: 'center',
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}',
        },
        label: {
          normal: {
            color: '#333',
            fontSize: 16,
            formatter(val) {
              // var reg = /[\u4e00-\u9fa5]/g;
              // var strs = val.name.match(reg).join("");
              // var num = val.name.replace(/[\u4e00-\u9fa5]/g,'')
              // strs = strs.split('');
              const strs = val.name.split('');
              let str = '';
              for (var i = 0, s; s = strs[i++];) {
                str += s;
                if (!(i % 12)) str += '\n';
              }
              return str;
              // return str + num
            },
          },
        },
        series: [
          {
            name: `${text}知识点占比`,
            type: 'pie',
            radius: [30, 110],
            center: ['50%', '50%'],
            roseType: 'area',
            data,
            itemStyle: {
              normal: {
                color(params) {
                  // 自定义颜色
                  if (data.length < 11) {
                    var colorList = ['#E7BCF3', '#FB7293', '#FF9F7F', '#FFDB5C', '#9EE6B7', '#32C5E9', '#37A2DA', '#8378EA', '#AA78EA', '#78A5EA'];
                    return colorList[params.dataIndex];
                  }
                  var colorList = ['#E7BCF3', '#FB7293', '#FF9F7F', '#ECCD5E', '#9EE6B7', '#00CDFF', '#23A6FF', '#6D5FEB', '#BC42E1', '#6EA3F5',
                    '#F39DE8', '#F55F5F', '#F4984C', '#D6B418', '#4ED4BC', '#28F3DF', '#207FBE', '#3BEB6D', '#782BDB', '#AEE742', '#F3BCCB',
                    '#F26BE0', '#FABE6D', '#D2D51A', '#4DD28C', '#14AACA', '#77CAFF', '#5333C2', '#BA69F7', '#3278FF'];
                  let newColor = [];
                  while (colorList.length) {
                    const index = parseInt(Math.random() * colorList.length);
                    newColor = newColor.concat(colorList.splice(index, 1));
                  }
                  // let listIndex = parseInt(Math.random()*colorList.length)
                  // return colorList[listIndex]
                  // console.log(newColor[params.dataIndex])
                  return newColor[params.dataIndex];
                },

              },
            },
          },
        ],
      };

      if (option && typeof option === 'object') {
        myChart.setOption(option, true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h2{
  width: 358px;
  height: 40px;
  margin: 58px auto 32px auto;
  font-size: 20px;
  line-height: 40px;
  text-align: center;
  background: url("~@/assets/img/sub_headbg.png") no-repeat;
  background-size: cover;
}
.pie-custom{
  margin: 0 auto;
}
.pie-exam-title{
  height:14px;
  font-size:14px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(102,102,102,1);
  line-height:14px;
  text-align: center;
}
</style>
